<div class="display-utils-col display-utils-gap-24">
  <div>
    <div class="title display-utils-col display-utils-center-center display-utils-gap-16">
      <div *ngIf="type" class="pme-icon" [ngClass]="{
        'pme-icon-error' : type == 'error',
        'pme-icon-warn' : type == 'warn',
        'pme-icon-success' : type == 'success',
        'pme-icon-info' : type == 'info' || type == 'shopping'
      }">
        <img [src]="iconPath" class="pme-alert-icon">
      </div>

      <h1 class="mat-headline" [innerHTML]="title" [ngClass]="{
            'pme-title-warn' : type == 'warn',
            'pme-title-success' : type == 'success',
            'pme-title-error' : type == 'error',
            'pme-title-info' : type == 'info' || type == 'shopping'
          }"></h1>
    </div>

    <ng-content></ng-content>
  </div>
  <div class="display-utils-center" *ngIf="this.showButton">
    <a mat-flat-button color="primary" href="{{this.redirectURL}}">{{buttonName}}</a>
  </div>
</div>